import { AnzsicCPIType, ClassType, Construction, Cover, CoverType } from '~/types/cover';
import { RiskClassCode } from '~/types/risk';

export const SMALL_BUSINESS_SHORT = 'SB';
export const INDUSTRY_LIMIT = 12;
export const OCCUPATION_CATEGORY_LIMIT = 12;
export const OCCUPATION_LIMIT = 6;
export const SPECIFIED_ITEM_LIMIT = 2501;
export const TOTAL_COVER_VALUE_LIMIT = 50000;
export const TOTAL_SPECIFIED_ITEMS_LIMIT = 15;

export const MAX_PLUMBING_LICENCES: number = 1;
export const SUCCESS = 'SUCCESS';
export const MODAL_HELPER_LEFT = 550;
export const CUSTOMER_HISTORY_HELPER_LEFT = 565;
export const DEFAULT_EXCESS = 500;
export const CYBERSOURCE_MERCHANT_ID = 'anzqbe_ib_id';
export const INDEMNITY_PERIOD_DEFAULT = 12;
export const MANUAL_ADDRESS_STREET_CHAR_LIMIT = 40;
export const MANUAL_ADDRESS_SUBURB_CHAR_LIMIT = 25;
export const CALL_CENTER_CONTACT_NUMBER = '133723';
export const INTERESTED_PARTIES_PER_COVER_LIMIT = 5;
export const CURRENCY_TEXTFIELD_LIMIT = 9;
export const RETRY_MESSAGE = 'Something went wrong processing your payment. Please try again.';
export const RISK_BPK_LIABILITY = 'riskBPKLiability';
export const RISK_BPK_GENERAL_PROPERTY_MACHINERY_BREAKDOWN =
  'riskBPKGeneralPropertyMachineryBreakdown';
export const RISK_BPK_FIRE_BUSINESS_INTERRUPTION = 'riskBPKFireBusinessInterruption';
export const RISK_BPK_THEFT_MONEY_GLASS = 'riskBPKTheftMoneyGlass';
export const CLAIM_COUNT_QUESTION_ID = '1';

export const COVER_CATEGORIES = [
  {
    id: '4',
    description: 'Mobile phones and tools of trade',
  },
  {
    id: '5',
    description: 'Laptops, notepads and tablets',
  },
  {
    id: '3',
    description: 'Radio equipment',
  },
  {
    id: 'A',
    description: 'Amplifiers, speakers and sound equipment',
  },
  {
    id: '8',
    description: 'Photography and video equipment',
  },
  {
    id: '7',
    description: 'Surveying equipment',
  },
  {
    id: '9',
    description: 'Scientific and medical equipment',
  },
  {
    id: '2',
    description: 'Cleaning and office equipment',
  },
  {
    id: '1',
    description: 'Compressors and heavy machinery',
  },
];

export const CONSTRUCTION_YEARS = [
  { id: '1', description: 'Before 1941' },
  { id: '2', description: '1941 - 1980' },
  { id: '3', description: '1981 - 2000' },
  { id: '4', description: '2001 - 2010' },
  { id: '6', description: '2011 - 2020' },
  { id: '7', description: `2021 - present` },
];

export const INDEMNITY_PERIOD_OPTIONS = [
  {
    text: '6',
    value: '6',
  },
  {
    text: '12',
    value: '12',
  },
  {
    text: '24',
    value: '24',
  },
  {
    text: '36',
    value: '36',
  },
];

export const LIABILITY_LIMIT_OPTIONS = [
  {
    text: '$5M',
    value: 5000000,
  },
  {
    text: '$10M',
    value: 10000000,
  },
  {
    text: '$20M',
    value: 20000000,
  },
];

export const EPS_OPTIONS = [
  {
    text: '0 - 20%',
    value: '20',
  },
  {
    text: 'Over 20%',
    value: '>20',
  },
];

export const CONSTRUCTION_BUILDING_OPTIONS = [
  { text: 'Brick walls, concrete floors', value: Construction.BrickWallsConcreteFloors },
  { text: 'Brick walls, timber floors', value: Construction.BrickWallsWoodFloors },
  { text: 'Other', value: Construction.Other },
];

export const CONSTRUCTION_INFO_LIST = [
  {
    id: '1',
    header: 'Brick walls, concrete floors',
    sections: [
      {
        subHeader: 'Buildings where externals walls are:',
        infoList: [
          'Stone, brick, brick veneer, concrete block or pre-cast concrete',
          'Fibro, ribbed steel, ribbed aluminium or corrugated iron walls (excluding aluminium-clad with polystyrene foam sandwich interior) on a steel frame',
        ],
      },
      {
        subHeader: 'And where all floors and staircases are:',
        infoList: ['Concrete, pre-cast concrete, concrete block or brick'],
      },
    ],
  },
  {
    id: '2',
    header: 'Brick walls, timber floors',
    sections: [
      {
        subHeader: 'Buildings where external walls are:',
        infoList: [
          'Stone, brick, brick veneer, concrete block or pre-cast concrete',
          'Fibro, ribbed steel, ribbed aluminium or corrugated iron walls (excluding aluminium-clad with polystyrene foam sandwich interior) on a steel frame',
        ],
      },
      {
        subHeader:
          'And where floors and/or ceilings (including frames, skirting boards and cornices), and/or staircases are:',
        infoList: ['All or part timber'],
      },
    ],
  },
  {
    id: '3',
    header: 'Other',
    sections: [
      {
        subHeader: 'Buildings where external walls are:',
        infoList: [
          'Timber on timber or a steel frame',
          'Fibro or iron on a wooden frame (regardless of floor materials)',
        ],
      },
    ],
  },
];

export const EPS_INFO_LIST = [
  {
    id: '1',
    header: 'Expanded polystyrene (EPS)',
    sections: [
      {
        subHeader: 'Buildings where 20% or more of the walls feature EPS, including:',
        infoList: [
          'Buildings partly lined with EPS panels',
          'Buildings with EPS panels installed for aesthetic or insulation purposes',
          'Buildings with polyurethane foam or similar sprayed directly onto walls',
        ],
      },
    ],
  },
];

export const THEFT_SECURITY_OPTIONS = [
  { text: 'Deadlocks on external doors', value: 'A' },
  { text: 'Deadlocks on external doors and bars on windows or local alarm', value: 'B' },
  { text: 'Deadlocks on external doors and back-to-base alarm', value: 'C' },
  { text: 'Business in after-hours security building with no external access', value: 'D' },
];

export const MONEY_SI_OPTIONS = [
  { text: '2500', value: '2500' },
  { text: '5000', value: '5000' },
  { text: '10000', value: '10000' },
  { text: '15000', value: '15000' },
  { text: '20000', value: '20000' },
];

export const TAX_AUDIT_SI_OPTIONS = [5000, 10000, 20000, 50000];

export const ANZSIC_TO_CPI_TYPES: Record<string, AnzsicCPIType[]> = {
  '423153': [AnzsicCPIType.ElectricianQLD, AnzsicCPIType.PlumberVIC],
  '423205': [AnzsicCPIType.ElectricianQLD],
  '423210': [AnzsicCPIType.ElectricianQLD],
  '423215': [AnzsicCPIType.ElectricianQLD],
  '423222': [AnzsicCPIType.ElectricianQLD],
  '423226': [AnzsicCPIType.ElectricianQLD],
  '423227': [AnzsicCPIType.ElectricianQLD],
  '423228': [AnzsicCPIType.ElectricianQLD],
  '423229': [AnzsicCPIType.ElectricianQLD],
  '423306': [AnzsicCPIType.ElectricianQLD],
  '423307': [AnzsicCPIType.ElectricianQLD],
  '423325': [AnzsicCPIType.ElectricianQLD],
  '423405': [AnzsicCPIType.ElectricianQLD],
  '423415': [AnzsicCPIType.ElectricianQLD],
  '423420': [AnzsicCPIType.ElectricianQLD],
  '526135': [AnzsicCPIType.ElectricianQLD],
  '526130': [AnzsicCPIType.ElectricianQLD],
  '526145': [AnzsicCPIType.ElectricianQLD],
  '526151': [AnzsicCPIType.ElectricianQLD],
  '423145': [AnzsicCPIType.PlumberVIC],
  '423142': [AnzsicCPIType.PlumberVIC],
  '423141': [AnzsicCPIType.PlumberVIC],
  '423130': [AnzsicCPIType.PlumberVIC],
  '423150': [AnzsicCPIType.PlumberVIC],
  '423143': [AnzsicCPIType.PlumberVIC],
  '423151': [AnzsicCPIType.PlumberVIC],
  '423105': [AnzsicCPIType.PlumberVIC],
  '423152': [AnzsicCPIType.PlumberVIC],
};

export const CLAUSE_CODE_CPI_ELECTRICIAN_QLD = 'BPP9EL';
export const CLAUSE_CODE_CPI_PLUMBER_VICTORIA = 'BPP9PL';
export const CLAUSE_CODE_NAME_OF_LANDLORD = 'BPPENL';
export const STAMP_DUTY_CLAUSE_CODE = 'BPPSBE';
export const FLOOD_CLAUSE_CODE = 'BFPDI6';

export const CLASS_TYPE_TO_COVER: { [key in ClassType]: Cover } = {
  [ClassType.LIABILITY]: Cover.Liability,
  [ClassType.PROPERTY]: Cover.BuildingAndContents,
  [ClassType.BUSINESS_INTERRUPTION]: Cover.BusinessInterruption,
  [ClassType.GENERAL_PROPERTY]: Cover.PortableItems,
  [ClassType.THEFT]: Cover.Theft,
  [ClassType.MONEY]: Cover.Money,
  [ClassType.GLASS]: Cover.Glass,
  [ClassType.MACHINERY]: Cover.Breakdown,
  [ClassType.TAX_AUDIT]: Cover.TaxAudit,
};

export const COVER_TO_CLASS_TYPE: { [key in Cover]: ClassType } = {
  [Cover.Liability]: ClassType.LIABILITY,
  [Cover.BuildingAndContents]: ClassType.PROPERTY,
  [Cover.BusinessInterruption]: ClassType.BUSINESS_INTERRUPTION,
  [Cover.PortableItems]: ClassType.GENERAL_PROPERTY,
  [Cover.Theft]: ClassType.THEFT,
  [Cover.Money]: ClassType.MONEY,
  [Cover.Glass]: ClassType.GLASS,
  [Cover.Breakdown]: ClassType.MACHINERY,
  [Cover.TaxAudit]: ClassType.TAX_AUDIT,
};

export const COVER_TYPE_TO_COVER: Record<CoverType, Cover> = {
  LIABILITY: Cover.Liability,
  PROPERTY: Cover.BuildingAndContents,
  BUSINESS_INTERRUPTION: Cover.BusinessInterruption,
  GENERAL_PROPERTY: Cover.PortableItems,
  THEFT: Cover.Theft,
  MONEY: Cover.Money,
  GLASS: Cover.Glass,
  BREAKDOWN: Cover.Breakdown,
  TAX_AUDIT: Cover.TaxAudit,
};

export const COVER_TO_RISK_CLASS: { [key in Cover]: RiskClassCode } = {
  [Cover.Liability]: RiskClassCode.Liability,
  [Cover.BuildingAndContents]: RiskClassCode.BuildingAndContents,
  [Cover.BusinessInterruption]: RiskClassCode.BuildingAndContents,
  [Cover.PortableItems]: RiskClassCode.PortableItems,
  [Cover.Theft]: RiskClassCode.TheftMoneyGlass,
  [Cover.Money]: RiskClassCode.TheftMoneyGlass,
  [Cover.Glass]: RiskClassCode.TheftMoneyGlass,
  [Cover.Breakdown]: RiskClassCode.TheftMoneyGlass,
  [Cover.TaxAudit]: RiskClassCode.Liability,
};

export const PROPERTY_VALUE_MIN = 100000;
